import styled from 'styled-components';
import React from 'react';
import { withCssSelector } from '../shared/withCssSelector';
import { ButtonColorDefinition, ButtonColors, ButtonVariant, IconPosition } from './ButtonVariant';
import { ButtonSize, ButtonSizeDefinition, ButtonSizes } from './ButtonSize';
import { Icon, IconName } from '../icon';
import { basicButtonStyling, sizeDependantStyling, variantStyling, } from './buttonStyling';

const StyledButton = styled.button`

	display: flex;
	${basicButtonStyling}
`;

const StyledButtonVariant = styled(StyledButton)<{
	$colorDefinition: ButtonColorDefinition;
	$sizeDefinition: ButtonSizeDefinition;
	$hasLabel: boolean;
	$hasIcon: boolean;
	$iconPosition: IconPosition;
	$active?: boolean;
	$textButton: boolean;
	$maximizeSpaceBetween?: boolean;
	$rounded?: boolean;
}>`
	${props => sizeDependantStyling(
		props.$sizeDefinition, props.$hasLabel, props.$hasIcon, props.$iconPosition
	)}
	${props => variantStyling(props.$colorDefinition, props.$textButton, props.$active, props.$rounded)}
	${props => props.$maximizeSpaceBetween ? `
		justify-content: space-between;
		gap: ${props.$sizeDefinition.paddingHorizontal * 2}px;
		padding-left: 10px;
		padding-right: 10px;
	` : ''}
`;

export type ButtonProps = {	
	size?: ButtonSize,
	variant?: ButtonVariant,
	label?: string,
	icon?: IconName,
	rounded?: boolean,
	active?: boolean,
	iconPosition?: IconPosition,
	maximizeSpaceBetween?: boolean,
} & React.ComponentPropsWithoutRef<'button'>

export const Button = withCssSelector(React.forwardRef<HTMLButtonElement, ButtonProps>(
	function Button({
		size = 'compact',
		variant = 'outline',
		label,
		icon,
		children,
		active,
		iconPosition = 'left',
		maximizeSpaceBetween,
		rounded = false,
		...other
	}, ref) {

		const colorDefinition = ButtonColors[variant];
		const sizeDefinition = ButtonSizes[size];

		return <StyledButtonVariant 
			ref={ref}
			$colorDefinition={colorDefinition}
			$sizeDefinition={sizeDefinition}
			$hasLabel={Boolean(label || children)}
			$hasIcon={Boolean(icon)}
			$iconPosition={iconPosition}
			$textButton={variant === 'link'}
			$maximizeSpaceBetween={maximizeSpaceBetween}
			type='button'
			$active={active}
			$rounded={rounded}
			{...other}
		>
			{icon && iconPosition !== 'right' && <Icon icon={icon} />}
			{label && <span>{label}</span>}
			{children}
			{icon && iconPosition === 'right' && <Icon icon={icon} />}
		</StyledButtonVariant>;
	}
), StyledButton.toString());
